import { SCORE_THRESHOLDS } from '@/services/constants';

function normalizeScore(score) {
    if (score === null || score === undefined) return null;

    const numericScore = typeof score === 'number' ? score : Number(score);
    if (!Number.isFinite(numericScore)) return null;
    if (numericScore < 0 || numericScore > 100) return null;
    return numericScore;
}

/**
 * Get status string based on score
 * @param {number} score - The score/percentage value
 * @returns {string} - Status: 'danger', 'warning', 'success', or 'neutral'
 */
export function getScoreStatus(score) {
    const normalizedScore = normalizeScore(score);
    if (normalizedScore === null) return 'neutral';

    if (normalizedScore < SCORE_THRESHOLDS.DANGER_THRESHOLD) return 'danger';
    if (normalizedScore < SCORE_THRESHOLDS.SUCCESS_THRESHOLD) return 'warning';
    return 'success';
}

/**
 * Get CSS color variable based on score
 * @param {number} score - The score/percentage value
 * @returns {string} - CSS variable: danger/warning/success/neutral color
 */
export function getScoreColor(score) {
    const normalizedScore = normalizeScore(score);
    if (normalizedScore === null) return 'var(--neutral-700)';

    if (normalizedScore < SCORE_THRESHOLDS.DANGER_THRESHOLD)
        return 'var(--danger)';
    if (normalizedScore < SCORE_THRESHOLDS.SUCCESS_THRESHOLD)
        return 'var(--warning)';
    return 'var(--success)';
}
